import React from 'react'
import {useTranslation} from 'react-i18next'

import {ScreenReaderOnly} from '../../../theme/visibility'

import {SpinnerOverlay, StyledSpinnerContainer, SpinnerText} from './styles'

const LoadingIndicator = () => {
  const {t} = useTranslation('common')

  return (
    <SpinnerOverlay role="alert" aria-live="polite">
      <StyledSpinnerContainer>
        <svg viewBox="25 25 50 50" xmlns="http://www.w3.org/2000/svg">
          <circle cx="50" cy="50" r="20" fill="none" strokeWidth="4" />
        </svg>
        <SpinnerText>{t('loading')}</SpinnerText>
        <ScreenReaderOnly>{t('resultsLoading')}</ScreenReaderOnly>
      </StyledSpinnerContainer>
    </SpinnerOverlay>
  )
}

export default LoadingIndicator
